export default "__VITE_ASSET__5ba8bed8__"